export default {
  title: 'Work',

  banner: {
    carousel: {
      first: 'UI/UX Design & Development studio in Rio',
      second: 'Our mission is to help products grow through design.',
      third: '<b>Ui.Ux.Dev</b> <br/> We only make digital products and services'
    },

    scheduleMeeting: 'AGENDAR UM CALL'
  },

  calendar: {
    title: 'Agende uma reunião'
  },

  content: {
    knowMore: 'SAIBA MAIS',

    left: {
      title: 'Redesign para impulsionar',
      text: 'Para marcas que estão prontas para acelerar seu crescimento. Você tem um bom produto que precisa de suporte profissional de UX ou design para crescer ainda mais rápido. Nosso ponto ótimo.'
    },
    right: {
      title: 'Design para lançamentos',
      text: 'Para produtos que estão apenas começando. Você tem um conceito claro em mente e está procurando um parceiro experiente de design de UX / UI para ajudá-lo a se preparar para o mercado.'
    }
  }
};
